export const DIVISION_SECTION = {
    WEB: {
        PROJECTS: "공공·기업 IT 프로젝트의 개발과 기술 컨설팅을 지원합니다. 데이터 플랫폼과 업무 시스템 구축 경험을 바탕으로 R&D 과제 기획과 기술 연구를 병행합니다.",
        DEVELOPMENT: "고객사의 아이디어와 요구사항을 웹·모바일 서비스와 업무 시스템으로 구현합니다. AI를 활용한 개발 경험을 더해 서비스 구축부터 기능개선과 유지보수까지 지원합니다.",
        SERVICES: "주말농장 서비스를 웹과 안드로이드에서 운영합니다. 음성 인터페이스 SaaS는 기획·연구 단계로, 새로운 자체 서비스 구현을 준비합니다.",
        EDUCATION: "실제 개발 경험을 프로젝트 중심의 교육으로 나눕니다. 교육 콘텐츠 제작에도 AI를 활용하며 실무와 교육을 연결합니다.",
    }
};
